// services/customerService.ts
import axiosInstance from "../services/axiosInstance";
import { Customer } from "../Interface/Customer";




export const fetchCustomers = async (): Promise<Customer[]> => {
  const response = await axiosInstance.get("/customers");
  return response.data.data; // assuming the customers are inside response.data.data
};




export const addCustomer = async (customerData: any) => {
  try {
    const response = await axiosInstance.post("/Customers", customerData);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Error adding customer");
  }
};

export const deleteCustomer = async (id: number): Promise<{ data: string }> => {
  const response = await axiosInstance.delete(`/Customer/${id}`);
  return response;
};



// customerService.ts


export const GetCountry = async () => {
  const response = await axiosInstance.get("/GetCountry");
  return response.data.data; // should return [{ id: 1, name: "India" }, ...]
};

export const GetCurrency = async () => {
  const response = await axiosInstance.get("/GetCurrency");
  console.log("Currency API Response:", response.data);
  return response.data.data;
};


export const GetPayTerms = async () => {
  const response = await axiosInstance.get("/GetPayTerms");
  return response.data.data;
};



// // export const updateCustomer = async (data: any) => {
// //   const response = await axiosInstance.put("/UpdateCustomer", data); // adjust path if different
// //   return response.data;
// // };
// export const updateCustomer = async (data: any) => {
  
//   const response = await axiosInstance.put("/UpdateCustomer", data);
//   return response.data;
// };
export const updateCustomer = async (payload: any) => {
  
  return axiosInstance.put("/UpdateCustomer", payload);
};
